/**
 * A link to a certain page, an anchor tag
 */

import styled from 'styled-components';

const ModalHeader = styled.div`
  //background-color: #f7c315;
  font-size: 1.5rem;
  font-weight: bold;
  height: 32px;
  padding-left: 10px;
  padding-right: 10px;
  text-transform: uppercase;
  color: #f9b115;
  background: rgb(0 0 0 / 80%);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2500;
`;

export default ModalHeader;
